import { render } from "./HemerotecaImago.vue?vue&type=template&id=031793ac&scoped=true&lang=html"
import script from "./HemerotecaImago.vue?vue&type=script&lang=js"
export * from "./HemerotecaImago.vue?vue&type=script&lang=js"

import "./HemerotecaImago.vue?vue&type=style&index=0&id=031793ac&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031793ac"]])

export default __exports__